import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { type QuickReply } from '../model/chatTypes';

interface QuickReplyButtonsProps {
  quickReplies: QuickReply[];
  buttonsQuestion: string | null;
  onQuickReply: (text: string) => void;
}

export const QuickReplyButtons: React.FC<QuickReplyButtonsProps> = ({
  quickReplies,
  buttonsQuestion,
  onQuickReply,
}) => {
  if (!quickReplies.length) return null;

  return (
    <Box sx={{ px: 2, py: 1 }}>
      {buttonsQuestion && (
        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
          {buttonsQuestion}
        </Typography>
      )}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 0.5,
        }}
      >
        {quickReplies.map((reply) => (
          <Chip
            key={reply.id}
            label={reply.text}
            variant="outlined"
            color="primary"
            size="small"
            onClick={() => onQuickReply(reply.text)}
            sx={{ cursor: 'pointer' }}
          />
        ))}
      </Box>
    </Box>
  );
};
